/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRequestLegalInfo
 */
export interface CreateOrganizationRequestLegalInfo {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    entityType?: CreateOrganizationRequestLegalInfoEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    legalEntityId: string;
}


/**
 * @export
 */
export const CreateOrganizationRequestLegalInfoEntityTypeEnum = {
    Pf: 'PF',
    Sl: 'SL',
    Sa: 'SA',
    Coop: 'COOP',
    Sc: 'SC',
    Other: 'OTHER',
    _601: '601',
    _603: '603',
    _605: '605',
    _606: '606',
    _607: '607',
    _608: '608',
    _609: '609',
    _610: '610',
    _611: '611',
    _612: '612',
    _614: '614',
    _615: '615',
    _616: '616',
    _620: '620',
    _621: '621',
    _622: '622',
    _623: '623',
    _624: '624',
    _625: '625',
    _626: '626',
    _628: '628',
    _629: '629',
    _630: '630'
} as const;
export type CreateOrganizationRequestLegalInfoEntityTypeEnum = typeof CreateOrganizationRequestLegalInfoEntityTypeEnum[keyof typeof CreateOrganizationRequestLegalInfoEntityTypeEnum];


/**
 * Check if a given object implements the CreateOrganizationRequestLegalInfo interface.
 */
export function instanceOfCreateOrganizationRequestLegalInfo(value: object): value is CreateOrganizationRequestLegalInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestLegalInfoFromJSON(json: any): CreateOrganizationRequestLegalInfo {
    return CreateOrganizationRequestLegalInfoFromJSONTyped(json, false);
}

export function CreateOrganizationRequestLegalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequestLegalInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'],
        'taxId': json['taxId'],
        'legalEntityId': json['legalEntityId'],
    };
}

export function CreateOrganizationRequestLegalInfoToJSON(json: any): CreateOrganizationRequestLegalInfo {
    return CreateOrganizationRequestLegalInfoToJSONTyped(json, false);
}

export function CreateOrganizationRequestLegalInfoToJSONTyped(value?: CreateOrganizationRequestLegalInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'entityType': value['entityType'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
        'email': value['email'],
        'taxId': value['taxId'],
        'legalEntityId': value['legalEntityId'],
    };
}

